module.exports = __webpack_public_path__ + "static/img/rodapeLogo.6d32b08.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imagens/DOE-AL/rodapeLogo.png
// module id = 8nuk
// module chunks = 1